<template>
  <section>
    <label>
      Deal Servings Saving Cost
    </label>
    <table class="table table-bordered"
           :key="randomValue"
           style="text-align: center"
    >
      <thead>
        <tr>
          <th>Serving Name</th>
          <th>Original Price</th>
          <th>Saving Cost</th>
        </tr>
      </thead>

      <tbody>
        <tr v-if="dealServings.length === 0">
          <td colspan="4" style="text-align: left">No Servings Available Against This Deal Item.</td>
        </tr>
        <tr v-for="servings in dealServings"
            v-bind:key="servings.id"
        >
          <td> {{servings.serving}}</td>
          <td> RS.&nbsp;{{servings.price}}</td>
          <td>
            <div class='input-group col-md-12'>
              <span class="input-group-addon disabled">
                <span class="">RS.</span>
              </span>
              <input type="number"
                     id="saving_cost"
                     class="form-control"
                     v-model="servings.savingCost"
                     min="0"
                     required
                     pattern="/\d+/g"
              />
            </div>
          </td>
      </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
export default {
  name: "DealServingsSavingCost",
  props:{
    dealServings: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      randomValue: Math.random(),
    }
  },
  watch: {
    dealServings(){
      console.log(this.dealServings)
    }
  }
}
</script>

<style scoped>

</style>